import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor, useLocation } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import { ftMostrarPrecioNormalMayoreo } from '../ProductsPage/ProductosPageHelper';
import cuponImage from '../../images/descuento.webp';
export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [address, setAddress] = useState('');
    const [cuponAplicado, setCuponAplicado] = useState(localStorage.getItem('cupon') || '');
    const [cupon, setCupon] = useState("");
    const [sincronizarStates, setSincronizarStates] = useState(false);
    const [codigos, setCodigos] = useState([]);
    const [shippingCost, setShippingCost] = useState(160); // si la opción predeterminada es express, inicia con 160
    const locationRouterDom = useLocation();
    // Si NO está en "/Productos", permitimos anclar los links:
    const [activateAnchor] = useState(
        locationRouterDom.pathname !== "/Productos"
    );
    useEffect(() => {
        cargarContacto();
    }, []);

    // Sincronizar con state cuponAplicado
    useEffect(() => {
        if (!sincronizarStates) return;
        const cupones = codigos.map((item) => item.codigo);
        if (cupones.includes(cupon.toUpperCase())) {
            setCuponAplicado(cupon);
        }
    }, [sincronizarStates]);

    useEffect(() => {
        // Calcular el precio total al cargar el carrito o al actualizar los productos
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += item.precio * item.cantidad;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    // Calcular precio total (sin envío) y aplicar descuento
    useEffect(() => {
        let total = 0;
        const codigoDescuento = codigos.find(
            (item) => item.codigo === cuponAplicado
        );
        let descuentoActualizado = codigoDescuento ? codigoDescuento.descuento : 0;
        setDescuento(descuentoActualizado);

        cartItems.forEach((item) => {
            total +=
                Number(
                    ftMostrarPrecioNormalMayoreo({ cuponAplicado, producto: item })
                ) * Number(item.cantidad);
        });
        setTotalPrice(total);
    }, [cartItems, cuponAplicado, codigos]);

    // Determinar costo de envío cuando cambie `deliveryOption`
    useEffect(() => {
        // Si es express -> $160
        // Si es mayoreo -> $250
        // Si es correos -> $60
        // Si es moto -> costo al recibir

        if (deliveryOption === "express") {
            setShippingCost(160);
        } else if (deliveryOption === "mayoreo") {
            setShippingCost(250);
        } else if (deliveryOption === "correos") {
            setShippingCost(60);
        } else {
            // 'moto'
            setShippingCost(0);
        }
    }, [deliveryOption]);


    useEffect(() => {
        cargarProductos();
    }, [isFocused]);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
                return {
                    ...producto,
                    cantidad: cartItem.cantidad,
                    item: cartItem.item,
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused]);

    // Abrir y cerrar el segundo modal (Detalles)
    const openModal2 = async () => {

        //revisamos si hay stock suficiente
        const formData = new FormData();
        formData.append("productos", JSON.stringify(cartItems));

        const response = await fetch(`${baseURL}/stockCheckPost.php`, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        if (data.mensaje == 'Ok') {
            setModalIsOpen2(true);
        } else {

            Swal.fire({
                title: 'Lo sentimos nos falta stock',
                html: data.mensaje,
                imageUrl: require('../../images/no_stock.png'), // Ruta de la imagen local
                imageWidth: 100, // Ancho de la imagen
                imageHeight: 100,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, ajustar',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.isConfirmed) {
                    const index = cartItems.findIndex(i => i.idProducto === data.idProducto && i.item === data.item);

                    let nuevaCantidad = 0;

                    if (data.item === 'Ch') {
                        nuevaCantidad = data.stockItem1;
                    } else if (data.item === 'M') {
                        nuevaCantidad = data.stockItem2;
                    } else if (data.item === 'G') {
                        nuevaCantidad = data.stockItem3;
                    } else if (data.item === 'Xg') {
                        nuevaCantidad = data.stockItem4;
                    } else if (data.item === 'Xxg') {
                        nuevaCantidad = data.stockItem5;
                    }

                    if (index !== -1) {
                        // Si lo encontramos, actualizar la cantidad
                        const updatedCartItems = [...cartItems];
                        updatedCartItems[index].cantidad = nuevaCantidad;
                        setCartItems(updatedCartItems);
                        localStorage.setItem("cart", JSON.stringify(updatedCartItems));
                            } else {
            // Item no encontrado
        }

                }
            });
        }

    }

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    // const openModal2 = () => {
    //     setModalIsOpen2(true);
    // };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const removeFromCart = (id, talla) => {
        const updatedCart = cartItems.filter(
            (producto) => !(producto.idProducto === id && producto.item === talla)
        );
        setCartItems(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
    };


    useEffect(() => {
        cargarCodigos();

    }, []);

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    // Enviar mensaje a WhatsApp
    const handleWhatsappMessage = () => {
        const codigoDescuento = codigos.find(
            (item) => item.codigo === cuponAplicado
        );
        let descuentoActualizado = codigoDescuento ? codigoDescuento.descuento : 0;

        // Calculamos total de productos con precio normal o mayoreo
        let totalPriceCalculado = 0;
        cartItems.forEach((item) => {
            totalPriceCalculado +=
                ftMostrarPrecioNormalMayoreo({ cuponAplicado, producto: item }) *
                item.cantidad;
        });
        // Aplico descuento
        let totalPriceWithDiscount = totalPriceCalculado - descuentoActualizado;
        if (totalPriceWithDiscount < 0) totalPriceWithDiscount = 0;

        // Sumamos costo de envío
        const finalTotal = totalPriceWithDiscount + shippingCost;

        const formattedTotal = finalTotal
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const phoneNumber = `${contactos.telefono}`;

        const cartDetails = cartItems.map((item) => {
            const p = ftMostrarPrecioNormalMayoreo({ cuponAplicado, producto: item });
            return `\n✅ *${item.titulo}* 
       Cantidad: ${item.cantidad}
       Precio: ${moneda} ${p?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} 
       ${item?.item}`;
        });

        let noteMessage = "";
        if (location.trim() !== "") noteMessage += `\n✅ Ubicación: ${location}`;
        if (name.trim() !== "") noteMessage += `\n✅ Nombre: ${name}`;
        if (noteText.trim() !== "") noteMessage += `\n✅ Nota: ${noteText}`;

        if (codigo.trim() !== "") {
            noteMessage += `\n✅ Codigo : ${codigo}
                      ✅ Descuento de : ${moneda} ${descuentoActualizado
                    ?.toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
        }

        const entrega =
            deliveryOption === "express"
                ? "Estafeta express nacional: se enviará a domicilio"
                : deliveryOption === "mayoreo"
                    ? "Estafeta mayoreo: se enviará a domicilio"
                    : deliveryOption === "correos"
                        ? "Correos de México: se enviará a domicilio"
                        : "Moto Uber Guadalajara (costo al recibir)";

        const paymentMessage =
            paymentMethod === "transferencia"
                ? "Pago por transferencia bancaria"
                : paymentMethod === "efectivo"
                    ? "Pago en efectivo"
                    : "Otro (PayPal/Mercado Pago)";

        const message = `¡Hola! 🌟 Estoy interesado en encargar:
      ${cartDetails.join("")}
      ------------------------------------>
      ${noteMessage}
      ✅ ${entrega}
      ✅ ${paymentMessage}

      ------------------------------------>
      *Total con envío: ${moneda} ${formattedTotal}*
      *Descuento aplicado: ${moneda} ${descuentoActualizado}*
      *Costo de envío: ${moneda} ${shippingCost}*
    `;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
            message
        )}`;

        // Limpiamos campos
        setName("");
        setLocation("");
        setNoteText("");
        setCodigo("");
        setDescuento(descuentoActualizado);

        // Cerrar ambos modales
        // onClose(); // Cierra modal principal
        setModalIsOpen2(false);

        return whatsappUrl;
    };


    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        }
    };


    //pedido-------------------------------------------------------------------
    const [mensaje, setMensaje] = useState('');
    const crearPedido = async () => {
        setMensaje('Procesando...');

        try {
            // Construir la lista de productos del pedido
            const productosPedido = cartItems?.map(item => {
                return {
                    idProducto: item?.idProducto,
                    titulo: item?.titulo,
                    cantidad: item?.cantidad,
                    item: item?.item,
                    precio: item?.precio,
                    imagen: obtenerImagen(item)

                }
            });
            // Convertir la lista de productos a JSON
            const productosPedidoJSON = JSON.stringify(productosPedido);
            // Calcular el precio total del pedido
            let totalPrice = 0;
            cartItems.forEach(item => {
                totalPrice += item?.precio * item?.cantidad;
            });

            // Obtener el descuento del código de descuento
            const codigoDescuento = codigos?.find(item => item?.codigo === codigo);
            let descuentoCodigo = 0;

            if (codigoDescuento) {
                descuentoCodigo = codigoDescuento?.descuento;
            }

            // Aplicar el descuento del código de descuento
            const totalPriceWithDiscount = totalPrice - descuentoCodigo;

            // Enviar el pedido con el precio total descontado
            const formData = new FormData();

            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPriceWithDiscount);
            formData.append('nombre', name);
            formData.append('email', email);
            formData.append('telefono', telefono);

            const entrega = deliveryOption === 'delivery' ? address : 'Retiro en personalmente';
            formData.append('entrega', entrega);

            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('estado', 'Pendiente');
            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            if (data.mensaje) {
                setMensaje('');
                Swal.fire(
                    'Pedido enviado!',
                    data.mensaje,
                    'success'
                );
                setName('')
                setCodigo('')
                setNoteText('')
                closeModal()
                closeModal2()
                clearCart()
                localStorage.removeItem("cupon");
                setCuponAplicado("");
                // Obtener la URL de WhatsApp y abrir en nueva pestaña
                const whatsappUrl = handleWhatsappMessage();

                // Crear un enlace y simular un clic en él para abrir en nueva pestaña
                const link = document.createElement('a');
                link.href = whatsappUrl;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);

                // Usar setTimeout para asegurar que el clic ocurra después de que el navegador haya procesado el evento actual
                setTimeout(() => {
                    link.click();
                    document.body.removeChild(link);
                }, 100);

            } else if (data?.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                'Error de conexión. Por favor, inténtelo de nuevo.',
                'error'
            );

        }
    };

    const handleSubmitCupon = (e, accion) => {
        e.preventDefault();
        if (accion === "Agregar") {
            const cupones = codigos.map((item) => item.codigo);
            if (cupones.includes(cupon.toUpperCase())) {
                localStorage.setItem("cupon", cupon.toUpperCase());
                setCuponAplicado(
                    e.target.value?.length > 0
                        ? e.target.value.toUpperCase()
                        : e.target.value
                );
                setSincronizarStates(true);
                toast.success("Cupón aplicado", { autoClose: 1000 });
            } else {
                toast.error("Cupón no válido", { autoClose: 1000 });
                return;
            }
        } else {
            localStorage.removeItem("cupon");
            setCuponAplicado("");
            setCupon("");
            setSincronizarStates(false);
            toast.success("Cupón eliminado", { autoClose: 1000 });
        }
    };

    // Cálculo del subtotal de productos (sin envío)
    const subtotalProductos = totalPrice - descuento < 0 ? 0 : totalPrice - descuento;
    
    // Cálculo final con descuento y envío (para mostrarlo en la vista previa del carrito)
    const finalPrice = subtotalProductos + shippingCost;

    const totalArticulos = cartItems.reduce((total, producto) => total + producto.cantidad, 0);
    return (
        <div>
            {/* <ToastContainer /> */}
            <button onClick={openModal} className='cartIconFixed'>
                {
                    // Calcular el total de artículos
                    <span>{totalArticulos}</span>
                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ?
                    (<p className='nohay'> No hay productos</p>)
                    : (<>
                        <div className="modal-content-cart">


                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>

                                    {cartItems.map((item, index) => (
                                        <div key={item?.idProducto} className='cardProductCart' >
                                            {activateAnchor ? (
                                                <Anchor
                                                    to={`/producto/${item?.idProducto
                                                        }/${item?.titulo?.replace(/\s+/g, "-")}`}
                                                    onClick={false}
                                                >
                                                    <img src={obtenerImagen(item)} alt="imagen" />
                                                </Anchor>
                                            ) : (
                                                <img src={obtenerImagen(item)} alt="imagen" />
                                            )}
                                            <div className='cardProductCartText'>
                                                <h3>{item.titulo}</h3>
                                                <span>
                                                    {item?.item}
                                                </span>
                                                <strong>
                                                    {moneda}{" "}
                                                    {ftMostrarPrecioNormalMayoreo({
                                                        cuponAplicado,
                                                        producto: item,
                                                    })
                                                        ?.toString()
                                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                </strong>
                                            </div>
                                            <div className="deColumn">
                                                <button
                                                    onClick={() =>
                                                        removeFromCart(item.idProducto, item.item)
                                                    }
                                                    className="deleteCart"
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                                <div className="deFlexCantidad">
                                                    <button onClick={() => decreaseQuantity(index)}>
                                                        -
                                                    </button>
                                                    <span>{item.cantidad}</span>
                                                    <button onClick={() => increaseQuantity(index)}>
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {/* Sección para agregar cupón */}
                        <div className="addCuponCartContainer">
                            <form
                                onSubmit={(e) =>
                                    handleSubmitCupon(
                                        e,
                                        `${cuponAplicado ? "Eliminar" : "Agregar"}`
                                    )
                                }
                            >
                                <div className="cuponCartContainer">
                                    <img src={cuponImage} alt="cuponImage" style={{ width: "40px", height: "40px" }} />
                                    <h4>Aplicar cupón:</h4>
                                </div>
                                <input
                                    type="text"
                                    value={cuponAplicado || cupon}
                                    onChange={(e) => {
                                        setCupon(e.target.value.toLocaleUpperCase());
                                    }}
                                    required
                                    maxLength={20}
                                    disabled={cuponAplicado}
                                />

                                <div>
                                    <button
                                        type="submit"
                                        className={`${cuponAplicado ? "btnDelCupon" : "btnAddCupon"
                                            }`}
                                    >
                                        {cuponAplicado ? "Eliminar" : "Agregar"}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="deColumnCart">
                            {/* Subtotal sin envío */}
                            <h4>
                                Importe: {moneda}{" "}
                                {subtotalProductos?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            </h4>
                            <h4>
                                {cuponAplicado
                                    ? cupon === "MAYOREO30" || cuponAplicado === "MAYOREO30"
                                        ? `Prendas: ${totalArticulos} piezas de 30`
                                        : cupon === "MAYOREO50" || cuponAplicado === "MAYOREO50"
                                            ? `Prendas: ${totalArticulos} piezas de 50`
                                            : cupon === "MAYOREO100" || cuponAplicado === "MAYOREO100"
                                                ? `Prendas: ${totalArticulos} piezas de 100`
                                                : cupon === "MAYOREO200" || cuponAplicado === "MAYOREO200"
                                                    ? `Prendas: ${totalArticulos} piezas de 200`
                                                    : `Prendas: ${totalArticulos} piezas`
                                    : `Prendas: ${totalArticulos} piezas`}
                            </h4>

                            <div className="deFLexBtns">
                                {/* Abrir segundo modal para datos del pedido */}
                                {cuponAplicado
                                    ? cupon === "MAYOREO30" || cuponAplicado === "MAYOREO30"
                                        ? totalArticulos >= 30 ? <button className="btnWpp" onClick={openModal2} >Comprar</button> : <button className="btnWppDisabled">Comprar</button>
                                        : cupon === "MAYOREO50" || cuponAplicado === "MAYOREO50"
                                            ? totalArticulos >= 50 ? <button className="btnWpp" onClick={openModal2} >Comprar</button> : <button className="btnWppDisabled">Comprar</button>
                                            : cupon === "MAYOREO100" || cuponAplicado === "MAYOREO100"
                                                ? totalArticulos >= 100 ? <button className="btnWpp" onClick={openModal2} >Comprar</button> : <button className="btnWppDisabled">Comprar</button>
                                                : cupon === "MAYOREO200" || cuponAplicado === "MAYOREO200"
                                                    ? totalArticulos >= 200 ? <button className="btnWpp" onClick={openModal2} >Comprar</button> : <button className="btnWppDisabled">Comprar</button>
                                                    : <button className="btnWpp" onClick={openModal2} >Comprar</button>
                                    : <button className="btnWpp" onClick={openModal2} >Comprar</button>
                                }

                            </div>
                        </div>

                        {/* Sub-modal de detalles para el pedido (WhatsApp, etc.) */}
                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className="deFLex">
                                {/* Botón de regreso dentro del segundo modal */}
                                <button onClick={closeModal2}>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                                <h4>Agregar Detalles</h4>
                            </div>

                            <div className="modal-send-form">
                                <input
                                    type="text"
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Nombre completo (obligatorio)"
                                    autoComplete="on"
                                />

                                <input
                                    type="number"
                                    id="telefono"
                                    value={telefono}
                                    onChange={(e) => setTelefono(e.target.value)}
                                    placeholder="Teléfono/WhatsApp (obligatorio)"
                                    autoComplete="on"
                                />

                                <div className="deFLexRadio">
                                    <label>Envío</label>

                                    {/* 1) Express = $160 */}
                                    <div onClick={() => setDeliveryOption("express")}>
                                        <input
                                            type="radio"
                                            id="express"
                                            name="deliveryOption"
                                            value="express"
                                            checked={deliveryOption === "express"}
                                            onChange={() => setDeliveryOption("express")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="express">
                                            Estafeta 1-10 prendas (2-5 días) $160
                                        </label>
                                    </div>

                                    {/* 2) Mayoreo = $250 */}
                                    <div onClick={() => setDeliveryOption("mayoreo")}>
                                        <input
                                            type="radio"
                                            id="mayoreo"
                                            name="deliveryOption"
                                            value="mayoreo"
                                            checked={deliveryOption === "mayoreo"}
                                            onChange={() => setDeliveryOption("mayoreo")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="mayoreo">
                                            Estafeta 30-200 prendas (2-5 días) $250
                                        </label>
                                    </div>

                                    {/* 3) Correos = $60 */}
                                    <div onClick={() => setDeliveryOption("correos")}>
                                        <input
                                            type="radio"
                                            id="correos"
                                            name="deliveryOption"
                                            value="correos"
                                            checked={deliveryOption === "correos"}
                                            onChange={() => setDeliveryOption("correos")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="correos">Correos de México (5-10 días) $60</label>
                                    </div>

                                    {/* 4) Moto uber = costo al recibir */}
                                    <div onClick={() => setDeliveryOption("moto")}>
                                        <input
                                            type="radio"
                                            id="moto"
                                            name="deliveryOption"
                                            value="moto"
                                            checked={deliveryOption === "moto"}
                                            onChange={() => setDeliveryOption("moto")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="moto">
                                            Moto Uber en Guadalajara $ al recibir
                                        </label>
                                    </div>
                                </div>

                                <input
                                    type="text"
                                    id="address"
                                    name="address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    placeholder="Calle, número, colonia, ciudad, código postal (obligatorio)"
                                    autoComplete="on"
                                />

                                <div className="deFLexRadio">
                                    <label>Formas de pago</label>

                                    <div>
                                        <input
                                            type="radio"
                                            id="transferencia"
                                            name="paymentMethod"
                                            value="transferencia"
                                            checked={paymentMethod === "transferencia"}
                                            onChange={() => setPaymentMethod("transferencia")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="transferencia">Transferencia bancaria</label>
                                    </div>

                                    <div>
                                        <input
                                            type="radio"
                                            id="efectivo"
                                            name="paymentMethod"
                                            value="efectivo"
                                            checked={paymentMethod === "efectivo"}
                                            onChange={() => setPaymentMethod("efectivo")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="efectivo">Deposito en efectivo</label>
                                    </div>

                                    <div>
                                        <input
                                            type="radio"
                                            id="otro"
                                            name="paymentMethod"
                                            value="otro"
                                            checked={paymentMethod === "otro"}
                                            onChange={() => setPaymentMethod("otro")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="otro">Otro (PayPal/Mercado Pago)</label>
                                    </div>
                                </div>

                                <textarea
                                    placeholder="Agrega una nota (opcional)"
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                />
                                <fieldset className="deNonefieldset">
                                    <legend>Productos</legend>
                                    <textarea
                                        name="productos"
                                        value={cartItems
                                            .map(
                                                (item) =>
                                                    `${item.titulo}, x ${item.cantidad}, ${item.item}, ${item.categoria
                                                    }, ${item.precio}, ${obtenerImagen(item)}`
                                            )
                                            .join("\n")}
                                        readOnly
                                    />
                                </fieldset>

                                {/* Botón para finalizar pedido */}
                                {mensaje ? (
                                    <button type="button" className="btn" disabled>
                                        {mensaje}
                                    </button>
                                ) : (
                                    <div style={{ padding: "20px 40px" }}>
                                        <button type="button" onClick={crearPedido} className="btnWpp">
                                            Pedir por WhatsApp
                                            <img src={whatsappIcon} alt="WhatsApp" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </Modal>

                    </>)}

            </Modal>
        </div >
    );
}
